/* unplugin-vue-components disabled */import { render } from "./appMain.vue?vue&type=template&id=3e47c50b&scoped=true"
import script from "./appMain.vue?vue&type=script&lang=js"
export * from "./appMain.vue?vue&type=script&lang=js"

import "./appMain.vue?vue&type=style&index=0&id=3e47c50b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e47c50b"]])

export default __exports__